// extracted by mini-css-extract-plugin
module.exports = {"page":"__9DSr6QvR"};